import React from 'react'
import PropTypes from 'prop-types'

import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'

// material-ui components
import { makeStyles } from '@material-ui/core/styles'
import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js'
import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle.js'

import InputLabel from '@material-ui/core/InputLabel'

// core components
import GridContainer from '../../components/Grid/GridContainer.js'
import GridItem from '../../components/Grid/GridItem.js'

const useSelectStyles = makeStyles(customSelectStyle)
const useInputStyles = makeStyles(customInputStyle)

export default function CustomDates ({ startDate, setStartDate, endDate, setEndDate, comparisonDate, setComparisonDate }) {
  const changeStartDate = function (date) {
    setStartDate(date)
    handleStartDateChange(date)
  }

  const changeEndDate = function (date) {
    setEndDate(date)
    handleEndDateChange(date)
  }

  const changeComparisonDate = function (date) {
    setComparisonDate(date)
    handleComparisonDateChange(date)
  }

  const [selectedStartDate, handleStartDateChange] = React.useState(startDate)
  const [selectedEndDate, handleEndDateChange] = React.useState(endDate)
  const [selectedComparisonDate, handleComparisonDateChange] = React.useState(comparisonDate)

  const selectClasses = useSelectStyles()
  const inputClasses = useInputStyles()

  return <GridContainer>
    <GridItem xs={6} sm={6} md={4} lg={4}>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12}>
          <div style={{ paddingBottom: '20px' }}>
            <InputLabel shrink className={selectClasses.selectLabel}>
              Start Date
            </InputLabel>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                InputProps={{ className: inputClasses.input }}
                clearable
                fullWidth
                autoOk
                value={selectedStartDate}
                onChange={date => changeStartDate(date)}
                format="dd/MM/yyyy"
                disableFuture
              />
            </MuiPickersUtilsProvider>
          </div>
        </GridItem>
      </GridContainer>
    </GridItem>
    <GridItem xs={6} sm={6} md={4} lg={4}>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12}>
          <div style={{ paddingBottom: '20px' }}>
            <InputLabel shrink className={selectClasses.selectLabel}>
              End Date
            </InputLabel>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                InputProps={{ className: inputClasses.input }}
                clearable
                fullWidth
                autoOk
                value={selectedEndDate}
                onChange={date => changeEndDate(date)}
                format="dd/MM/yyyy"
                disableFuture
                minDate={selectedStartDate}
                maxDate={selectedStartDate ? new Date(selectedStartDate).setMonth(selectedStartDate.getMonth() + 13) : null}
                disabled={!selectedStartDate}
              />
            </MuiPickersUtilsProvider>
          </div>
        </GridItem>
      </GridContainer>
    </GridItem>
    <GridItem xs={12} sm={12} md={4} lg={4}>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12}>
          <div style={{ paddingBottom: '10px' }}>
            <InputLabel shrink className={selectClasses.selectLabel}>
              Comparison Start Date
            </InputLabel>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                InputProps={{ className: inputClasses.input }}
                clearable
                fullWidth
                autoOk
                value={selectedComparisonDate}
                onChange={date => changeComparisonDate(date)}
                format="dd/MM/yyyy"
                maxDate={selectedStartDate}
                disableFuture
                disabled={!selectedStartDate}
              />
            </MuiPickersUtilsProvider>
          </div>
        </GridItem>
      </GridContainer>
    </GridItem>
  </GridContainer>
}

CustomDates.propTypes = {
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  setStartDate: PropTypes.func,
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  setEndDate: PropTypes.func,
  comparisonDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  setComparisonDate: PropTypes.func
}
